module.exports = __webpack_public_path__ + "static/img/industry_manufacturing.a276a61.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/site/industry_manufacturing.jpg
// module id = 2sbl
// module chunks = 0